import Vue from 'vue';
import Vuex from 'vuex';

//import CallCenterSendReport from './modules/CallCenterSendReport/index';
//import TimingShedule from './modules/TimingShedule/index';
//import Timing from './modules/Timing/index';

Vue.use(Vuex);

export default new Vuex.Store({
    state: {},
    mutations: {},
    actions: {},
    modules: {
        //'CallCenterSendReport': CallCenterSendReport,
        //'TimingShedule':        TimingShedule,
        //'Timing':               Timing,
    }
})